export function GetDottedID(dataObject) {
  if (dataObject == null) return null;

  var dottedDef = dataObject.GetFieldDefByID("DottedID");
  if (dottedDef == null) return null;

  var dottedID = dataObject.GetFieldValue(dottedDef);
  return dottedID;
}
